import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { componentRef } from './consts';

export default grapesjs.plugins.add('gjs-box-folder-list', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'box-folder-list',
    blocks: [componentRef],
    defaultStyle: true,
    labelTable: 'Box Folder List',
    labelBoxFolderListCategory: 'Advanced',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
